import PrMarqueeAlert from '@home/pages/studio/pr/components/PrMarqueeAlert';
import PrGameTitle from '@home/pages/studio/pr/components/PrGameTitle';
import PrNoticeMarquee from '@home/pages/studio/pr/components/PrNoticeMarquee';
import PrStudioMonthFilter from '@home/pages/studio/pr/components/PrStudioMonthFilter';
import PrMediaTable from '@home/pages/studio/pr/components/PrMediaTable';
import PrPressCommonTable from '@home/pages/studio/pr/components/PrPressCommonTable';
import PrChannelColorLegend from '@home/pages/studio/pr/components/PrChannelColorLegend';
import PrSummaryCards from '@home/pages/studio/pr/components/PrSummaryCards';
import PrTrendSection from '@home/pages/studio/pr/components/PrTrendSection';
import PrWorkspaceTabs, {
  PrTabPanel,
} from '@home/pages/studio/pr/components/PrWorkspaceTabs';
import PrStudioService from '@home/pages/studio/pr/components/PrStudioService';
import PrDownloadButton from '@home/pages/studio/pr/components/PrDownloadButton';
import PrAiSummary from '@home/pages/studio/pr/components/PrAiSummary';

export default {
  PrMarqueeAlert,
  PrGameTitle,
  PrNoticeMarquee,
  PrStudioMonthFilter,
  PrMediaTable,
  PrPressCommonTable,
  PrChannelColorLegend,
  PrSummaryCards,
  PrTabPanel,
  PrTrendSection,
  PrWorkspaceTabs,
  PrStudioService,
  PrDownloadButton,
  PrAiSummary,
};
